// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1359":"77e3c2f4","1708":"8ec347a6","2421":"bb2fedad","4163":"be9a6ef5","8286":"bb2fedad","9563":"3325ae6f"}[chunkId] + ".chunk.css";
};